import { Card, Grid } from "@mui/material";
import MDButton from "components/MDButton";
import CustomText from "components/customtext/customtext";
import React, { createRef } from "react";
import ReactToPrint from "react-to-print";

class ComponentToPrint extends React.Component {
  render() {
    return (
      <Grid container spacing={2} justifyContent={"center"}>
        {this.props.printerData.map((val, i) => (
          <Grid item lg={5}>
            <Card style={{ background: "aliceblue", padding: "10px" }}>
              <Grid container>
                <Grid lg={6} pl={2} style={{ height: "80%" }}>
                  <CustomText type="b" size={15}>
                    Slot Number : {val.slotNumber}
                  </CustomText>
                </Grid>
                <Grid lg={6} pl={2} pt={2}>
                  <Grid container>
                    <Grid item lg={6}>
                      <CustomText type="b" size={12}>
                        Name
                      </CustomText>
                    </Grid>
                    <Grid item lg={6}>
                      <CustomText
                        type="b"
                        size={12}
                        style={{ paddingLeft: "15px" }}
                      >
                        Consignment Number
                      </CustomText>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid lg={6} pl={2} style={{ height: "20%" }}>
                  <Grid container>
                    <Grid item lg={6}>
                      <CustomText type="p" size={12}>
                        <b>Loaded Volume</b> <br /> {val.loadedVolume}
                      </CustomText>
                    </Grid>
                    <Grid item lg={6}>
                      <CustomText type="p" size={12}>
                        <b> Available Volume</b>
                        <br /> {val.balanceVolume}
                      </CustomText>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid
                  lg={6}
                  pl={2}
                  style={{ height: "100px", overflow: "auto" }}
                >
                  {val.order.map((valu, i) => (
                    <Grid container>
                      <Grid item lg={6}>
                        <CustomText type="p" size={12}>
                          {valu.senderName}({val.customerCode})
                        </CustomText>
                      </Grid>
                      <Grid
                        item
                        lg={6}
                        justifyContent={"center"}
                        display={"flex"}
                      >
                        <CustomText type="p" size={12}>
                          {valu.orderNumber}
                        </CustomText>
                      </Grid>
                    </Grid>
                  ))}
                </Grid>

                {/* <Grid lg={6} py={2} style={{ height: "100px", overflow: "auto" }}></Grid> */}
              </Grid>
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  }
}

class Printer extends React.Component {
  constructor(props) {
    super(props);

    this.componentRef = createRef(); // Create a ref for the component
  }

  renderComponentToPrint() {
    return (
      <ComponentToPrint
        ref={(el) => (this.componentRef = el)}
        printerData={this.props.printerData}
      />
    );
  }

  render() {
    return (
      <div>
        <div style={{ alignContent: "left" }}></div>
        <Grid
          container
          alignItems="left"
          display="flex"
          justifyContent="end"
          pb={4}
        >
          <Grid item xs={12} md={4} spacing={2} lg={1}>
            <ReactToPrint
              trigger={() => (
                <MDButton
                  // onClick={this.renderComponentToPrint}
                  rel="noreferrer"
                  variant="gradient"
                  color="success"
                >
                  Print
                </MDButton>
              )}
              content={() => this.componentRef}
              pageStyle={`
    @page {
      size: A3; /* Set the page size to a larger value, e.g., A3 */
      margin: 1cm; /* Set margins as needed */
    }
    body {
      font-family: Arial, sans-serif; /* Set the font for the printed content */
      font-size: 12px; /* Decrease font size as needed */
    }
  `}
            />
          </Grid>

          <Grid item xs={12} md={4} spacing={2} lg={1}>
            <MDButton
              onClick={() => this.props.state(false)}
              rel="noreferrer"
              variant="gradient"
              color="warning"
            >
              Back
            </MDButton>
          </Grid>
        </Grid>
        <div style={{ width: "100%" }}>
          <ComponentToPrint
            ref={(el) => (this.componentRef = el)}
            printerData={this.props.printerData}
          />
        </div>
      </div>
    );
  }
}

export default Printer;
